import logo from './logo.svg';
import './App.css';
import SaamiTradestarLogistics from './Components/SaamiTradestarLogistics';
import Login from './Components/Login';
// import { useState } from "react";
import { useEffect, useState } from "react";
import api from "./api";
import SessionTimeout from "./Components/SessionTimeout";
import { RightsProvider } from "../src/Components/RightsContext";
function App() {

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [checkingSession, setCheckingSession] = useState(true);
  //after 30 min user logout with help of refresh
  // useEffect(() => {
  //   const loginTime = localStorage.getItem("loginTime");
  //   const savedLogin = localStorage.getItem("isLoggedIn");

  //   if (savedLogin === "true" && loginTime) {
  //     const now = Date.now();
  //     const diff = now - Number(loginTime);

  //     const thirtyMinutes = 30 * 60 * 1000;

  //     if (diff < thirtyMinutes) {
  //       setIsLoggedIn(true);
  //     } else {
  //       logoutUser();
  //     }
  //   }
  // }, []);

  //lgoicfor after 30 mins user auto logout without refresh
  useEffect(() => {
    checkSession();
  }, []);

  // const checkSession = () => {
  //   const loginTime = localStorage.getItem("loginTime");
  //   const savedLogin = localStorage.getItem("isLoggedIn");

  //   if (savedLogin === "true" && loginTime) {
  //     const now = Date.now();
  //     const diff = now - Number(loginTime);

  //     const thirtyMinutes = 30 * 60 * 1000;

  //     if (diff < thirtyMinutes) {
  //       setIsLoggedIn(true);

  //       // remaining time
  //       const remainingTime = thirtyMinutes - diff;

  //       // Auto logout exactly when session expires
  //       setTimeout(() => {
  //         logoutUser();
  //         alert("Session expired. Please login again.");
  //       }, remainingTime);
  //     } else {
  //       logoutUser();
  //     }
  //   }
  // };

  //ConCurrent Login
  
  // const checkSession = () => {
    const checkSession = async () => {
  const loginTime = sessionStorage.getItem("loginTime");
  const savedLogin = sessionStorage.getItem("isLoggedIn");
  const sessionTimeoutMinutes =
    Number(sessionStorage.getItem("sessionTimeoutMinutes")) || 120;

  if (savedLogin === "true" && loginTime) {

    const now = Date.now();
    const diff = now - Number(loginTime);

    const sessionTime = sessionTimeoutMinutes * 60 * 1000;

    if (diff < sessionTime) {
      // setIsLoggedIn(true);
      // Don't just trust localStorage — confirm the session is still
      // valid on the server before letting the user straight into the app.
      // This is what closes the "reopen a tab / paste the URL and you're
      // still in" bug: a stale-but-unexpired localStorage flag is no
      // longer enough on its own.
      try {
        const sessionToken = sessionStorage.getItem("sessionToken");
        await api.get("/check-session", {
          headers: {
            SessionToken: sessionToken
          }
        });
        setIsLoggedIn(true);
      } catch (error) {
        logoutUser();
      }
    } else {
      logoutUser();
    }
  }
    setCheckingSession(false);
};

  useEffect(() => {
    if (isLoggedIn) {
      const interval = setInterval(async () => {
        try {
          const sessionToken = sessionStorage.getItem("sessionToken");
          if (!sessionToken) return;

          // Standardize the URL. If /login works, /check-session should likely be at the same level.
          await api.get("/check-session", {
            headers: {
              SessionToken: sessionToken
            }
          });
        } catch (error) {
          console.error("Session check failed:", error.response?.status, error.response?.data || error.message);
          
          // Only logout if it's a 401 Unauthorized (which means token mismatch)
          if (error.response?.status === 401) {
            logoutUser();
            alert("Logged in from another PC. You have been logged out.");
          } else {
            console.warn("Session check error (Non-401):", error.message);
          }
        }
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [isLoggedIn]);

  const logoutUser = () => {
    // localStorage.removeItem("isLoggedIn");
    // localStorage.removeItem("token");
    // localStorage.removeItem("sessionToken");
    // localStorage.removeItem("username");
    // localStorage.removeItem("loginTime");
    // localStorage.removeItem("sessionTimeoutMinutes");
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("sessionToken");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("loginTime");
    sessionStorage.removeItem("sessionTimeoutMinutes");
    setIsLoggedIn(false);
  };

    if (checkingSession) {
    return <div className="App">{/* spinner / blank / splash screen */}</div>;
  }

  return (
    <div className="App">

      {/* {isLoggedIn ? (
        <SaamiTradestarLogistics setIsLoggedIn={setIsLoggedIn} logoutUser={logoutUser} />
      ) : (
        <Login setIsLoggedIn={setIsLoggedIn} />
      )} */}

      {/* logic for after 30 mins user is auto logout */}
      {isLoggedIn ? (
        // <SaamiTradestarLogistics logoutUser={logoutUser} />
        <RightsProvider>
         <>
        <SaamiTradestarLogistics logoutUser={logoutUser} />

        <SessionTimeout
            logoutUser={logoutUser}
        />
    </>
    </RightsProvider>
      ) : (
        <Login setIsLoggedIn={setIsLoggedIn} />
      )}
    </div>
  );
}

export default App;
